module.exports = __webpack_public_path__ + "img/rest.be5030ca.webp";